import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CssService } from 'src/app/services/css-service';

@Component({
  selector: 'app-fully-paid-dialog',
  templateUrl: './fully-paid-dialog.component.html',
})
export class FullyPaidDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<FullyPaidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pointOfSaleName: string, tableNumber: number },
    public cssService: CssService
  ) { }

  isClosing = false;
  selectedOption: string | null = null;

  onAnimationEnd() {
    if (this.isClosing)
      this.dialogRef.close(this.selectedOption);
  }
}
